module.exports = __webpack_public_path__ + "static/media/eye-icon.d22afc63.svg";